module.exports = __webpack_public_path__ + "img/hotel1.0d51e293.png";